import React from 'react';
import { ClipboardListIcon, HandCoinsIcon, CalendarCheck2Icon, ArrowRightIcon } from 'lucide-react';
export function HowItWorks() {
  return <section id="how-it-works" className="py-20 md:py-28 px-6 md:px-12 lg:px-16 bg-white relative overflow-hidden scroll-mt-24" data-id="element-227">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-228">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-slate-50 rounded-full opacity-50" data-id="element-229" />
        <div className="absolute top-1/2 -left-24 w-64 h-64 bg-slate-50 rounded-full opacity-50" data-id="element-230" />
      </div>

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-231">
        <div className="text-center mb-16 md:mb-24" data-id="element-232">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#0F172A] mb-6 tracking-tight" data-id="element-233">
            How The Process Works
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-234">
            Selling your house doesn't have to be complicated. We've boiled it
            down to three simple steps.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative" data-id="element-235">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-24 left-[16%] right-[16%] h-0.5 bg-slate-200" data-id="element-236" />

          {/* Step 1 */}
          <div className="relative group" data-id="element-237">
            <div className="bg-white rounded-2xl p-8 shadow-lg border border-slate-100 relative z-10 h-full transition-transform duration-300 hover:-translate-y-2 hover:shadow-xl" data-id="element-238">
              <div className="w-14 h-14 bg-white border-2 border-[#D4A24C] rounded-full flex items-center justify-center mb-5 shadow-sm group-hover:scale-110 transition-transform duration-300" data-id="element-239">
                <ClipboardListIcon className="w-6 h-6 text-[#D4A24C]" data-id="element-240" />
              </div>
              <div className="text-[10px] font-bold text-[#D4A24C] uppercase tracking-widest mb-2 opacity-80" data-id="element-241">
                Step 1
              </div>
              <h3 className="text-xl font-bold text-[#0F172A] mb-3" data-id="element-242">
                Tell us about your property
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-243">
                Fill out the short form or give us a call. We'll gather some
                basic info about your house and your situation. It's 100% free
                and there's no obligation.
              </p>
            </div>
          </div>

          {/* Step 2 */}
          <div className="relative group" data-id="element-244">
            <div className="bg-white rounded-2xl p-8 shadow-lg border border-slate-100 relative z-10 h-full transition-transform duration-300 hover:-translate-y-2 hover:shadow-xl" data-id="element-245">
              <div className="w-14 h-14 bg-white border-2 border-[#D4A24C] rounded-full flex items-center justify-center mb-5 shadow-sm group-hover:scale-110 transition-transform duration-300" data-id="element-246">
                <HandCoinsIcon className="w-6 h-6 text-[#D4A24C]" data-id="element-247" />
              </div>
              <div className="text-[10px] font-bold text-[#D4A24C] uppercase tracking-widest mb-2 opacity-80" data-id="element-248">
                Step 2
              </div>
              <h3 className="text-xl font-bold text-[#0F172A] mb-3" data-id="element-249">
                Get your fair cash offer
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-250">
                If it meets our buying criteria, we'll present you with a fair,
                no-obligation cash offer within 24 hours. No lowballing, just a
                straightforward number.
              </p>
            </div>
          </div>

          {/* Step 3 */}
          <div className="relative group" data-id="element-251">
            <div className="bg-white rounded-2xl p-8 shadow-lg border border-slate-100 relative z-10 h-full transition-transform duration-300 hover:-translate-y-2 hover:shadow-xl" data-id="element-252">
              <div className="w-14 h-14 bg-white border-2 border-[#D4A24C] rounded-full flex items-center justify-center mb-5 shadow-sm group-hover:scale-110 transition-transform duration-300" data-id="element-253">
                <CalendarCheck2Icon className="w-6 h-6 text-[#D4A24C]" data-id="element-254" />
              </div>
              <div className="text-[10px] font-bold text-[#D4A24C] uppercase tracking-widest mb-2 opacity-80" data-id="element-255">
                Step 3
              </div>
              <h3 className="text-xl font-bold text-[#0F172A] mb-3" data-id="element-256">
                Close on your timeline
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-257">
                You decide when we close. We use a reputable local title company
                and can close in as little as 7 days, or whenever works best for
                your schedule.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-16 text-center" data-id="element-258">
          <button onClick={() => {
          const form = document.getElementById('hero-form');
          form?.scrollIntoView({
            behavior: 'smooth'
          });
        }} className="inline-flex items-center bg-[#0F172A] hover:bg-[#152238] text-white font-bold py-4 px-8 rounded-full transition-colors group text-lg shadow-md" data-id="element-259">
            Start Step 1 Now
            <ArrowRightIcon className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-260" />
          </button>
        </div>
      </div>
    </section>;
}